const PatientTag = {
  EquipAppTreatment: "EQ_APP_TREAT",
};

enum TreatmentProgram {
  EquipAdult = "Equip Adult",
  EquipTreatment = "Equip treatment",
  Freeform = "Freeform",
}

const AdminEpisodeStatus: Record<string, AdminEpisodeStatus> = {
  Assessing: "Assessing",
  Closed: "Closed",
  Enrolled: "Enrolled",
  InTreatment: "In-treatment",
  New: "New",
  Paused: "Paused",
} as const satisfies Record<string, AdminEpisodeStatus>;

const UniversalStatusCode = {
  Assessing: "ASSESSING",
  Closed: "CLOSED",
  Discharged: "DISCHARGED",
  Fielded: "FIELDED",
  InTreatment: "IN_TREATMENT",
  NeverStarted: "NEVER_STARTED",
  New: "NEW",
  Onboarding: "ONBOARDING",
  Paused: "PAUSED",
  Qualified: "QUALIFIED",
  Unknown: "UNKNOWN",
} as const satisfies Record<string, UniversalStatusCode>;

const PreTreatmentUniversalStatusCodes: UniversalStatusCode[] = [
  UniversalStatusCode.Assessing,
  UniversalStatusCode.Fielded,
  UniversalStatusCode.New,
  UniversalStatusCode.Onboarding,
  UniversalStatusCode.Qualified,
];

const InTreatmentUniversalStatusCodes: UniversalStatusCode[] = [
  UniversalStatusCode.InTreatment,
  UniversalStatusCode.Paused,
];

const PostTreatmentUniversalStatusCodes: UniversalStatusCode[] = [
  UniversalStatusCode.Closed,
  UniversalStatusCode.Discharged,
];

enum PatientTreatmentPhases {
  InTreatment = "IN_TREATMENT",
  OutOfTreatment = "OUT_OF_TREATMENT",
  PostTreatment = "POST_TREATMENT",
  PreTreatment = "PRE_TREATMENT",
}

enum UserConsentType {
  Recording = "recording",
  TermsAndPrivacy = "termsAndPrivacy",
}

enum DeviceType {
  Mobile = "Mobile",
  Web = "Web",
}

export {
  AdminEpisodeStatus,
  DeviceType,
  InTreatmentUniversalStatusCodes,
  PatientTag,
  PatientTreatmentPhases,
  PostTreatmentUniversalStatusCodes,
  PreTreatmentUniversalStatusCodes,
  TreatmentProgram,
  UniversalStatusCode,
  UserConsentType,
};
